module.exports = __webpack_public_path__ + "static/media/bell.deb32913.png";